import {Injectable} from '@angular/core';
import {ApiClientService} from '../../core/services/api-client.service';
import {Nouveaute} from './nouveaute.model';

export type NouveautePayload = Omit<Nouveaute, '_id'> & { _id?: string };

@Injectable({
  providedIn: 'root',
})
export class NouveautesService extends ApiClientService {
  getAllNouveautes() {
    return this.get<Nouveaute[]>('/changelog/all');
  }

  getNouveauteImageURL(imageKey: string) {
    return this.getText(`/changelog/image?key=${imageKey}`);
  }

  uploadImages(files: File[]) {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return this.post<string[]>('/changelog/upload', formData);
  }

  saveNouveaute(nouveaute: NouveautePayload) {
    return this.put<Nouveaute>('/changelog', nouveaute);
  }

  deleteNouveaute(id: string) {
    return this.delete(`/changelog/${id}`);
  }
}


